import MyHeader from "./Components/MyHeader"
import Quote from "./Components/Quote"
import MyCalc from "./Components/Calculator"
import MyFooter from "./Components/MyFooter"

function App() {
  return (
    <div>
      < MyHeader />
      < MyCalc />
      < Quote />
      < MyFooter />
    </div>
  );
}

export default App;
